import React 		from 'react';
import PropTypes 	from 'prop-types';

import Preloader from './_Preloader.jsx';

export default class LazyLoad extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			showLoader: false,
		}
	}

	componentDidMount() {
		window.addEventListener('scroll', () => {
			if(!this.props.disable) {
				const currentScroll = Math.round(window.scrollY);
				const windowHeight 	= window.innerHeight;
				const lazyloader	 	= this.lazyloader;

				if(lazyloader) {
					const triggerPosition = lazyloader.offsetTop - windowHeight*1.5;

					if(currentScroll > triggerPosition) {
						this.setState({showLoader: true});

						this.props.callbackFunc();
					}
				}
			}
		});
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<section className={`l-flex l-center-v l-margin-top ${classes}`} ref={lazyloader => this.lazyloader = lazyloader}>
				{this.state.showLoader && this.returnLoader()}
			</section>
		);
	}

	returnLoader() {
		return (
			<Preloader/>
		);
	}
}

LazyLoad.propTypes = {
		classes:	PropTypes.string
	,	callbackFunc: PropTypes.function
}